import Assignment from "./Assignment";
import { Route } from "react-router-dom";

const routes = {
  key: "ASSIGNMENT",
  routes: ({ userScope }) => [
    <Route
      key={"assignment"}
      path={`${userScope}/assignment/response/client`}
      element={<Assignment />}
    />,
    <Route
      key={"assignment"}
      path={`${userScope}/assignment/response/prospection`}
      element={<Assignment />}
    />,
  ],
};
export default routes;
